import { postCompanyVacancy, createVacancyTemplate } from '../../api/postApi'
import {
  vacancyDataHelperUpdate,
  vacancySubmitHelper,
  templateSubmitHelper,
  templateDataHelperUpdate,
} from '../../helpers/vacancyManager.helper'
import { putCompanyVacancy, putTemplate } from '../../api/putApi'
import { setIsVacancyEnable, pathRestoreDeletedVacancy } from '../../api/patchApi'
import { deleteCompanyVacancy, hardDeleteCompanyVacancy, deleteVacancyTemplate } from '../../api/deleteApi'
import { notify } from '../../helpers/notify'
import { batch } from 'react-redux'
import { VACANCY } from './vacancyManager.types'

export const postVacancy = (data, archive, clearForm, type) => (dispatch) => {
  dispatch(setIsButtonEnable(false))

  postCompanyVacancy(vacancySubmitHelper(data, type))
    .then((response) => {
      dispatch(setIsButtonEnable(true))

      notify('Success', 'Vacancy was successfully created')

      clearForm()

      if (!archive) {
        dispatch(createVacancy(vacancyDataHelperUpdate(response, type)))
      } else {
        dispatch(incrementActiveVacancy())
      }
    })
    .catch((error) => {
      dispatch(setIsButtonEnable(true))
      notify.errorsList(error.errors)
    })
}

export const setIsButtonEnable = (payload) => ({
  type: VACANCY.SET_IS_BUTTON_ENABLE,
  payload,
})

export const updateVacancy = (data, id, type) => (dispatch) => {
  dispatch(setIsButtonEnable(false))
  putCompanyVacancy(vacancySubmitHelper(data, type), id)
    .then((response) => {
      dispatch(updateVacancyInfo(vacancyDataHelperUpdate(response, type)))
      dispatch(clearVacancyForm())
      dispatch(setIsButtonEnable(true))
      notify('Success', 'Vacancy was successfully update')
    })
    .catch((error) => {
      dispatch(setIsButtonEnable(true))
      notify.errorsList(error.errors)
    })
}

export const deleteVacancy = (id) => {
  return (dispatch) => {
    deleteCompanyVacancy(id)
      .then(() => {
        batch(() => {
          dispatch(removeVacancy(id))
          dispatch(clearVacancyForm())
          dispatch(incrementArchiveVacancy())
          dispatch(decrementActiveVacancy())
          dispatch(updateFilters({ deleted: true }))
        })

        notify('Success', 'Vacancy was successfully archived')
      })
      .catch((error) => notify.errorsList(error.errors))
  }
}

export const hardDeleteVacancy = (id) => {
  return (dispatch) => {
    hardDeleteCompanyVacancy(id)
      .then(() => {
        batch(() => {
          dispatch(removeVacancy(id))
          dispatch(decrementActiveVacancy())
        })

        notify('Success', 'Vacancy was successfully deleted')
      })
      .catch((error) => notify.errorsList(error.errors))
  }
}

export const removeVacancy = (payload) => ({
  type: VACANCY.REMOVE_FROM_VACANCIES_LIST,
  payload,
})

export const restoreDeletedVacancy = (id) => {
  return (dispatch) => {
    pathRestoreDeletedVacancy(id)
      .then(() => {
        batch(() => {
          dispatch(removeVacancy(id))
          dispatch(decrementArchiveVacancy())
          dispatch(incrementActiveVacancy())
          dispatch(updateFilters({ deleted: false }))
        })
      })
      .catch((error) => notify.errorsList(error.errors))
  }
}

export const updateFilters = (value) => (dispatch) => {
  dispatch(updateVacanciesFilter(value))
}

export const setVacancyStatus = (id, status) => {
  return (dispatch) => {
    setIsVacancyEnable(id, status)
      .then(() => {
        dispatch(setIsVacancyEnabled({ id, status }))
      })
      .catch((error) => notify.errorsList(error.errors))
  }
}

export const updateVacanciesFilter = (payload) => ({
  type: VACANCY.UPDATE_VACANCIES_FILTER,
  payload,
})

export const updateVacancyInfo = (payload) => ({
  type: VACANCY.UPDATE_VACANCY,
  payload,
})

export const createVacancy = (payload) => ({
  type: VACANCY.CREATE_NEW_VACANCY,
  payload: {
    ...payload,
  },
})

export const setIsVacancyEnabled = (payload) => ({
  type: VACANCY.SET_IS_VACANCY_ENABLED,
  payload,
})

export const updateVacanciesList = (payload) => ({
  type: VACANCY.UPDATE_VACANCIES_LIST,
  payload,
})

export const clearVacancyList = () => ({
  type: VACANCY.CLEAR_VACANCY_LIST,
})

export const editVacancy = (inEditId, vacancyType) => ({
  type: VACANCY.EDIT_VACANCY,
  payload: { inEditId, vacancyType },
})

export const incrementArchiveVacancy = () => ({
  type: VACANCY.INCREMENT_ARCHIVE_VACANCY,
})

export const decrementArchiveVacancy = () => ({
  type: VACANCY.DECREMENT_ARCHIVE_VACANCY,
})

export const incrementActiveVacancy = () => ({
  type: VACANCY.INCREMENT_ACTIVE_VACANCY,
})

export const decrementActiveVacancy = () => ({
  type: VACANCY.DECREMENT_ACTIVE_VACANCY,
})

export const clearVacancyForm = () => ({ type: VACANCY.CLEAR_VACANCY_FORM })

export const resetVacancies = () => ({
  type: VACANCY.RESET_VACANCIES,
})

export const setVacancyType = (payload) => ({
  type: VACANCY.SET_VACANCY_TYPE,
  payload,
})

export const clearVacancyType = () => ({ type: VACANCY.CLEAR_VACANCY_TYPE })

// Vacancy template actions

export const incrementTemplates = () => ({
  type: VACANCY.INCREMENT_TEMPLATES,
})

export const decrementTemplates = () => ({
  type: VACANCY.DECREMENT_TEMPLATES,
})

export const editTemplate = (inEditId, vacancyType, templateType) => ({
  type: VACANCY.EDIT_TEMPLATE,
  payload: { inEditId, templateType, vacancyType },
})

export const setTemplateType = (payload) => ({
  type: VACANCY.SET_TEMPLATE_TYPE,
  payload,
})

const createTemplate = (payload) => ({
  type: VACANCY.CREATE_NEW_TEMPLATE,
  payload,
})

export const postTemplate = (payload, clearForm, vacancyType, templateType) => (dispatch) => {
  dispatch(setIsButtonEnable(false))

  createVacancyTemplate(templateSubmitHelper(payload, vacancyType, templateType))
    .then((response) => {
      dispatch(setIsButtonEnable(true))
      dispatch(createTemplate(templateDataHelperUpdate(response, templateType)))
      dispatch(incrementTemplates())
      notify('Success', 'Vacancy template was successfully created')
      clearForm()
    })
    .catch((error) => {
      dispatch(setIsButtonEnable(true))
      notify.errorsList(error.errors)
    })
}

export const updateTemplate = (data, id, vacancyType, templateType) => (dispatch) => {
  dispatch(setIsButtonEnable(false))

  putTemplate(templateSubmitHelper(data, vacancyType, templateType), id)
    .then((response) => {
      dispatch(updateTemplateInfo(templateDataHelperUpdate(response, templateType)))
      dispatch(clearTemplateForm())
      dispatch(setIsButtonEnable(true))
      notify('Success', 'Template was successfully update')
    })
    .catch((error) => {
      dispatch(setIsButtonEnable(true))
      notify.errorsList(error.errors)
    })
}

export const updateTemplateInfo = (payload) => ({
  type: VACANCY.UPDATE_TEMPLATE_INFO,
  payload,
})

export const updateTemplatesList = (payload) => ({
  type: VACANCY.UPDATE_TEMPLATES_LIST,
  payload,
})

export const hardDeleteTemplate = (id) => (dispatch) => {
  deleteVacancyTemplate(id)
    .then(() => {
      dispatch({
        type: VACANCY.HARD_DELETE_TEMPLATE,
        payload: id,
      })
      dispatch(decrementTemplates())
      notify('Success', 'Template was successfully deleted')
    })
    .catch((error) => notify.errorsList(error.errors))
}

export const clearTemplatesList = () => ({
  type: VACANCY.CLEAR_TEMPLATES_LIST,
})

export const clearTemplateForm = () => ({ type: VACANCY.CLEAR_TEMPLATE_FORM })
